document.addEventListener('DOMContentLoaded', () => {
  // 1) Remove truly empty/whitespace-only <li> (including &nbsp; and <br>)
  document.querySelectorAll('li').forEach((el) => {
    const text = el.textContent.replace(/\u00A0/g, ' ').trim(); // &nbsp;
    const onlyBr = Array.from(el.childNodes).every((n) =>
      n.nodeType === 3 ? n.textContent.trim() === '' : (n.nodeType === 1 && n.tagName === 'BR')
    );

    const hasUsefulChildren = el.querySelector('img,svg,video,iframe,button,input,textarea,select,a');

    if (!hasUsefulChildren && (text === '' || onlyBr)) el.remove();
  });

  // 2) Remove "bullet-only" lines (common in Shopify policies after copy/paste)
  document.querySelectorAll('p, div, span').forEach((el) => {
    // only target small text blocks to avoid deleting real content
    if (el.children.length > 0) return;

    const t = el.textContent.replace(/\u00A0/g, ' ').trim();
    if (t === '•' || t === '·' || t === '◦') el.remove();
  });
});
